import axios from "axios";
import { apiAddress } from "../../config/server";
import { ApiBase } from "./baseApi";
import { AppointmentReportResponse } from "../../types/reports/appointmentReport";
import { AppointmentQueryPayload } from "../../types/reports/appointmentQuery";

const BASE_URL = `${apiAddress}/api/reports/appointments`;

export default class AppointmentReportingApi extends ApiBase {
  static async query(payload: AppointmentQueryPayload): Promise<AppointmentReportResponse> {
    const response = await this.post<AppointmentReportResponse>(`${BASE_URL}/query`, payload);
    return response.data.data;
  }

  static async exportCsv(payload: AppointmentQueryPayload): Promise<Blob> {
    const response = await axios.post(`${BASE_URL}/export`, payload, {
      responseType: "blob",
    });
    return response.data;
  }
}
